"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloseButton = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var Button_1 = __importDefault(require("./Button"));
var Message_1 = __importDefault(require("../i18n/Message"));
var CloseButton = function (props) {
    var loading = props.loading, onClick = props.onClick;
    return (react_1.default.createElement(Button_1.default, { size: "xxl", loading: loading, type: Button_1.default.TYPE_SECONDARY, onClick: onClick },
        react_1.default.createElement(Message_1.default, { messageId: 'button.close' })));
};
exports.CloseButton = CloseButton;
CloseButton.propTypes = {
    loading: prop_types_1.default.bool,
    onClick: prop_types_1.default.func,
};
exports.default = CloseButton;
CloseButton.displayName = 'CloseButton';
//# sourceMappingURL=CloseButton.js.map